var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseBold = function SvgCloseBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1362.9 1362.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M906.3 681.5 1328 259.9c46.6-46.6 46.6-122.1 0-168.6L1271.7 35c-46.6-46.6-122.1-46.6-168.6 0L681.5 456.6 259.9 34.9c-46.6-46.6-122.1-46.6-168.6 0L34.9 91.1c-46.6 46.6-46.6 122.1 0 168.6l421.7 421.7L35 1103.1c-46.6 46.6-46.6 122.1 0 168.6l56.2 56.2c46.6 46.6 122.1 46.6 168.6 0l421.6-421.6 421.6 421.6c46.6 46.6 122.1 46.6 168.6 0l56.2-56.2c46.6-46.6 46.6-122.1 0-168.6z"
  })));
};
export default SvgCloseBold;